import { twMerge } from "tailwind-merge";

import { InputWithClear } from "./InputWithClear";

interface AdvancedSettingInputsProps {
  /** Current mean (log_mean) value — edit-model string. */
  logMean: string;
  /** Current stdv (log_std_dev) value — edit-model string. */
  logStdDev: string;
  onChangeLogMean: (value: string) => void;
  onChangeLogStdDev: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  /** Red-border the Mean input (invalid: empty or non-number). */
  logMeanError?: boolean;
  /** Red-border the Stdv input (invalid: empty, non-number, or `<= 0`). */
  logStdDevError?: boolean;
  className?: string;
}

// Shared look with the weight input (also an InputWithClear) so the advanced
// row reads as one control set.
const FIELD_CLASS = "bg-white max-h-8 rounded-xl text-txtHeading";

/**
 * Mean value / Stdv value inputs shown under the "Advanced Settings" column.
 * Controlled — the values live in the weight reducer (per-attribute `z_score`)
 * so they reach the analysis payload under LOG_Z_SCORE. Reuses InputWithClear
 * for the number-only entry; Mean also permits negatives.
 */
export default function AdvancedSettingInputs({
  logMean,
  logStdDev,
  onChangeLogMean,
  onChangeLogStdDev,
  onBlur,
  disabled,
  logMeanError,
  logStdDevError,
  className
}: AdvancedSettingInputsProps) {
  return (
    <div className={twMerge("flex items-center gap-2", className)}>
      <InputWithClear
        value={logMean}
        onChange={onChangeLogMean}
        onBlur={onBlur}
        error={logMeanError}
        disabled={disabled}
        allowNegative
        inputMode="decimal"
        placeholder="Mean value"
        ariaLabel="Mean value"
        showClearButton={false}
        inputClassName="text-xs"
        className={FIELD_CLASS}
      />
      <InputWithClear
        value={logStdDev}
        onChange={onChangeLogStdDev}
        onBlur={onBlur}
        error={logStdDevError}
        disabled={disabled}
        inputMode="decimal"
        placeholder="Stdv value"
        ariaLabel="Stdv value"
        showClearButton={false}
        inputClassName="text-xs"
        className={FIELD_CLASS}
      />
    </div>
  );
}
